<app-menu></app-menu>
<div class="controlsign-page">
  <header class="page-header">
    <div>
      <h1>ControlSign</h1>
      <p>{{ 'CONTROLSIGN.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-header__actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="openRegisterModal()">
        <mat-icon>add</mat-icon>
        <span>Novo documento</span>
      </button>
    </div>
  </header>

  <nav class="cp-tabs controlsign-tabs">
    <button mat-stroked-button type="button" [class.active]="activeMainTab === 'dashboard'" (click)="setMainTab('dashboard')">
      <mat-icon>dashboard</mat-icon>
      Dashboard
    </button>
    <button mat-stroked-button type="button" [class.active]="activeMainTab === 'documents'" (click)="setMainTab('documents')">
      <mat-icon>description</mat-icon>
      Documentos
    </button>
  </nav>

  <section class="dashboard-grid" *ngIf="activeMainTab === 'dashboard'">
    <article class="dashboard-card">
      <h3>Documentos cadastrados</h3>
      <strong>{{ documents.length }}</strong>
      <small>Total na base</small>
    </article>
    <article class="dashboard-card">
      <h3>Assinaturas pendentes</h3>
      <strong>{{ dashboardTotalPending }}</strong>
      <small>Destinatários aguardando ação</small>
    </article>
    <article class="dashboard-card">
      <h3>Assinaturas concluídas</h3>
      <strong>{{ dashboardTotalDone }}</strong>
      <small>Finalizadas com sucesso</small>
    </article>
    <article class="dashboard-card">
      <h3>Total de envios</h3>
      <strong>{{ dashboardTotalRecipients }}</strong>
      <small>Destinatários notificados</small>
    </article>
  </section>

  <section class="table-card" *ngIf="activeMainTab === 'dashboard'">
    <div class="panel-header">
      <div>
        <h2>Últimos documentos</h2>
        <p>Resumo rápido dos documentos mais recentes.</p>
      </div>
    </div>
    <div class="table-wrapper" *ngIf="recentDocuments.length; else noDashboardDocs">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Título</th>
            <th>Criado em</th>
            <th class="col-center">Pendentes</th>
            <th class="col-center">Concluídos</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of recentDocuments">
            <td>{{ doc.id }}</td>
            <td><strong>{{ doc.title }}</strong></td>
            <td>{{ doc.created_at | date:'dd/MM/yy, HH:mm' }}</td>
            <td class="metric col-center">{{ doc.pending_recipients || 0 }}</td>
            <td class="metric col-center">{{ doc.done_recipients || 0 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noDashboardDocs>
      <p class="empty">Nenhum documento encontrado.</p>
    </ng-template>
  </section>

  <section class="register-page" *ngIf="activeMainTab === 'documents' && registerPageOpen">
    <header class="register-page__header">
      <div>
        <h2>Novo documento</h2>
        <p>Cadastre o documento, informe os e-mails dos signatários e confira o preview.</p>
      </div>
      <button mat-stroked-button type="button" (click)="closeRegisterModal()">Voltar</button>
    </header>

    <input #fileInput type="file" accept="application/pdf" hidden (change)="onFileSelected($event)">

    <div class="register-page__content">
      <section class="table-card">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cs-register-full">
          <mat-label>Tipo de envio *</mat-label>
          <mat-select [(ngModel)]="registerForm.send_type" name="register_send_type">
            <mat-option value="INTRANET">Intranet</mat-option>
            <mat-option value="EMAIL">E-mail</mat-option>
          </mat-select>
        </mat-form-field>

        <section class="details-toggle">
          <button mat-stroked-button type="button" class="details-toggle__trigger" (click)="toggleRegisterDetails()">
            <mat-icon>{{ registerDetailsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
            Detalhes
          </button>
          <div class="details-toggle__body" *ngIf="registerDetailsOpen">
            <div class="cp-form-row cs-register-grid">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field cs-register-full">
                <mat-label>{{ 'CONTROLSIGN.FORM.TITLE' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="registerForm.title" name="register_title" [placeholder]="'CONTROLSIGN.FORM.TITLE_PLACEHOLDER' | translate">
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cs-register-full">
                <mat-label>{{ 'CONTROLSIGN.FORM.TYPE' | translate }}</mat-label>
                <mat-select [(ngModel)]="registerForm.document_type" name="register_document_type">
                  <mat-option *ngFor="let option of documentTypeOptions" [value]="option.value">{{ option.labelKey | translate }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field cs-register-full cp-textarea">
                <mat-label>{{ 'CONTROLSIGN.FORM.DESC' | translate }}</mat-label>
                <textarea matInput rows="3" [(ngModel)]="registerForm.description" name="register_description" [placeholder]="'CONTROLSIGN.FORM.DESC_PLACEHOLDER' | translate"></textarea>
              </mat-form-field>
            </div>
          </div>
        </section>

        <div class="cp-field-controls cs-register-checks" *ngIf="registerForm.send_type === 'INTRANET'">
          <mat-checkbox [(ngModel)]="registerForm.require_read" name="require_read">{{ 'CONTROLSIGN.FORM.REQUIRE_READ' | translate }}</mat-checkbox>
          <mat-checkbox [(ngModel)]="registerForm.require_accept" name="require_accept">{{ 'CONTROLSIGN.FORM.REQUIRE_ACCEPT' | translate }}</mat-checkbox>
          <mat-checkbox [(ngModel)]="registerForm.require_agreement" name="require_agreement">{{ 'CONTROLSIGN.FORM.REQUIRE_AGREEMENT' | translate }}</mat-checkbox>
          <mat-checkbox [(ngModel)]="registerForm.require_signature" name="require_signature">{{ 'CONTROLSIGN.FORM.REQUIRE_SIGNATURE' | translate }}</mat-checkbox>
          <mat-checkbox [(ngModel)]="registerForm.require_selfie" name="require_selfie">{{ 'CONTROLSIGN.FORM.REQUIRE_SELFIE' | translate }}</mat-checkbox>
          <mat-checkbox [(ngModel)]="registerForm.require_geolocation" name="require_geolocation">{{ 'CONTROLSIGN.FORM.REQUIRE_GEOLOCATION' | translate }}</mat-checkbox>
        </div>

        <section class="signers-panel">
          <header>
            <h3>Lista de signatários</h3>
            <small>Digite e pressione Enter ou clique em adicionar.</small>
          </header>
          <div class="signers-input-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>E-mail do signatário</mat-label>
              <input
                matInput
                type="email"
                [(ngModel)]="signerEmailInput"
                name="signer_email_input"
                placeholder="nome@empresa.com"
                (keydown.enter)="$event.preventDefault(); addSignerEmail()">
            </mat-form-field>
          </div>
          <div class="signers-action-row">
            <button mat-raised-button color="primary" class="signer-add-btn" type="button" (click)="addSignerEmail()">Adicionar</button>
          </div>
          <div class="signers-chips" *ngIf="signerEmails.length; else noSignerEmails">
            <span class="signer-chip" *ngFor="let email of signerEmails">
              {{ email }}
              <button type="button" (click)="removeSignerEmail(email)">
                <mat-icon>close</mat-icon>
              </button>
            </span>
          </div>
          <ng-template #noSignerEmails>
            <p class="empty" *ngIf="registerForm.send_type === 'EMAIL'">Adicione ao menos um e-mail de signatário para enviar o documento.</p>
            <p class="empty" *ngIf="registerForm.send_type !== 'EMAIL'">Nenhum e-mail adicionado.</p>
          </ng-template>
        </section>

        <p class="feedback" *ngIf="registerFeedback">{{ registerFeedback }}</p>

        <footer class="entry-footer register-page__footer">
          <button mat-raised-button color="primary" type="button" (click)="submitDocument()" [disabled]="registerLoading || !canSubmitDocument">
            <mat-icon>send</mat-icon>
            {{ registerLoading ? ('COMMON.SENDING' | translate) : 'Enviar documento' }}
          </button>
        </footer>
      </section>

      <section class="table-card preview-panel">
        <header class="preview-panel__header">
          <h3>Preview do documento</h3>
          <button mat-stroked-button type="button" *ngIf="selectedFileName" (click)="fileInput.click()">Alterar documento</button>
        </header>
        <div class="preview-panel__body" *ngIf="registerPreviewSafeUrl; else previewEmpty">
          <iframe [src]="registerPreviewSafeUrl" class="preview-embed" title="Preview do documento"></iframe>
        </div>
        <ng-template #previewEmpty>
          <div
            class="preview-empty preview-dropzone"
            [class.dragging]="isDraggingFile"
            (click)="fileInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onFileDrop($event)">
            <mat-icon>picture_as_pdf</mat-icon>
            <p>Arraste o PDF aqui ou clique para selecionar o documento.</p>
          </div>
        </ng-template>
      </section>
    </div>
  </section>

  <section class="table-card" *ngIf="activeMainTab === 'documents' && !registerPageOpen">
    <div class="panel-header">
      <div>
        <h2>{{ 'CONTROLSIGN.LIST_TITLE' | translate }}</h2>
        <p>{{ 'CONTROLSIGN.LIST_DESC' | translate }}</p>
      </div>
      <div class="panel-actions">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field search-box search-box--muted">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            [placeholder]="'CONTROLSIGN.SEARCH' | translate"
            [(ngModel)]="searchTerm"
            (input)="applyDocumentFilter()">
        </mat-form-field>
      </div>
    </div>

    <div class="table-wrapper" *ngIf="!documentsError">
      <table *ngIf="pagedDocuments.length; else emptyDocuments">
        <thead>
          <tr>
        <th>ID</th>
        <th>{{ 'CONTROLSIGN.TABLE.TITLE' | translate }}</th>
            <th>{{ 'CONTROLSIGN.TABLE.CREATED_AT' | translate }}</th>
            <th>{{ 'CONTROLSIGN.TABLE.CREATED_BY' | translate }}</th>
            <th class="col-center">{{ 'CONTROLSIGN.TABLE.SENDS' | translate }}</th>
            <th class="col-center">{{ 'CONTROLSIGN.TABLE.PENDING' | translate }}</th>
            <th class="col-center">{{ 'CONTROLSIGN.TABLE.DONE' | translate }}</th>
            <th class="col-center">{{ 'CONTROLSIGN.TABLE.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of getDocumentRows()">
            <td (click)="toggleDocumentDispatches(doc)" class="toggle-cell">{{ doc.id }}</td>
            <td (click)="toggleDocumentDispatches(doc)" class="toggle-cell">
              <strong>{{ doc.title }}</strong>
            </td>
            <td>{{ doc.created_at | date:'dd/MM/yy, HH:mm' }}</td>
            <td>{{ doc.author_name || ('CONTROLSIGN.EMPTY' | translate) }}</td>
            <td class="metric col-center">{{ doc.total_recipients || 0 }}</td>
            <td class="metric col-center">
              <span class="status-pill status-pill--warning">{{ doc.pending_recipients || 0 }}</span>
            </td>
            <td class="metric col-center">
              <span class="status-pill status-pill--success">{{ doc.done_recipients || 0 }}</span>
            </td>
            <td class="actions col-center">
              <button type="button"
                      class="action-icon more"
                      [matMenuTriggerFor]="documentActionsMenu"
                      (menuOpened)="selectedDocumentForActions = doc"
                      title="Abrir ações">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyDocuments>
        <p class="empty">{{ 'CONTROLSIGN.EMPTY_LIST' | translate }}</p>
      </ng-template>
    </div>
    <p class="list-error" *ngIf="documentsError">{{ documentsError }}</p>
    <p class="list-error" *ngIf="deleteFeedback">{{ deleteFeedback }}</p>

    <div class="table-pagination" *ngIf="filteredDocuments.length > pageSize && !expandedDocumentId">
      <button type="button" (click)="changeDocumentPage(-1)" [disabled]="currentPage === 1">{{ 'PAGINATION.PREV' | translate }}</button>
      <span>{{ 'PAGINATION.PAGE' | translate:{ current: currentPage, total: totalDocumentPages } }}</span>
      <button type="button" (click)="changeDocumentPage(1)" [disabled]="currentPage >= totalDocumentPages">{{ 'PAGINATION.NEXT' | translate }}</button>
    </div>

    <mat-menu #documentActionsMenu="matMenu" class="controlsign-row-menu-panel" xPosition="before" yPosition="below" [hasBackdrop]="true">
      <button mat-menu-item type="button" (click)="openSelectedDocumentRecipients('PENDING')" [disabled]="!selectedDocumentForActions">
        <mat-icon>hourglass_bottom</mat-icon>
        <span>Ver pendentes</span>
      </button>
      <button mat-menu-item type="button" (click)="openSelectedDocumentRecipients('DONE')" [disabled]="!selectedDocumentForActions">
        <mat-icon>task_alt</mat-icon>
        <span>Ver finalizados</span>
      </button>
      <button
        mat-menu-item
        type="button"
        class="danger-item"
        (click)="deleteSelectedDocument()"
        [disabled]="!selectedDocumentForActions || deletingDocumentId === selectedDocumentForActions.id || !canDeleteSelectedDocument()"
        [attr.title]="selectedDocumentForActions && !canDeleteSelectedDocument() ? 'Não é possível excluir porque já houve interações.' : 'Excluir documento'">
        <mat-icon>delete</mat-icon>
        <span>Excluir documento</span>
      </button>
    </mat-menu>
  </section>

  <section class="dispatches-card" *ngIf="activeMainTab === 'documents' && !registerPageOpen && expandedDocumentId">
    <header>
      <div>
        <h2>Disparos de "{{ expandedDocumentTitle }}"</h2>
        <p>Liste de envios com status e detalhes.</p>
      </div>
      <div class="pagination">
        <button type="button" (click)="changeDispatchPage(-1)" [disabled]="dispatchesPage === 1">Anterior</button>
        <span>{{ dispatchesPage }} / {{ dispatchesTotalPages }}</span>
        <button type="button" (click)="changeDispatchPage(1)" [disabled]="dispatchesPage >= dispatchesTotalPages">Próxima</button>
      </div>
    </header>

    <div *ngIf="dispatchesLoading" class="list-status">Carregando disparos...</div>
    <p class="list-error" *ngIf="dispatchesError">{{ dispatchesError }}</p>

    <div *ngIf="dispatchFeedback" class="list-error">{{ dispatchFeedback }}</div>

    <table *ngIf="!dispatchesLoading && dispatches.length">
      <thead>
        <tr>
          <th>ID</th>
          <th>Nome</th>
          <th>Enviado em</th>
          <th>Enviado por</th>
          <th class="col-center">Envios</th>
          <th class="col-center">Pendentes</th>
          <th class="col-center">Finalizados</th>
          <th class="col-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dispatch of dispatches">
          <td>{{ dispatch.id }}</td>
          <td>{{ expandedDocumentTitle }}</td>
          <td>{{ dispatch.sent_at | date:'dd/MM/yy, HH:mm' }}</td>
          <td>{{ dispatch.sent_by_name || ('CONTROLSIGN.EMPTY' | translate) }}</td>
          <td class="metric col-center">{{ dispatch.total_recipients || 0 }}</td>
          <td class="metric col-center">
            <span class="chip warning">{{ dispatch.pending_recipients || 0 }}</span>
          </td>
          <td class="metric col-center">
            <span class="chip success">{{ dispatch.done_recipients || 0 }}</span>
          </td>
          <td class="actions col-center">
            <button type="button"
                    class="action-icon more"
                    [matMenuTriggerFor]="dispatchActionsMenu"
                    (menuOpened)="selectedDispatchForActions = dispatch"
                    title="Abrir ações">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="empty" *ngIf="!dispatchesLoading && !dispatches.length">Nenhum disparo encontrado.</p>

    <mat-menu #dispatchActionsMenu="matMenu" class="controlsign-row-menu-panel" xPosition="before" yPosition="below" [hasBackdrop]="true">
      <button mat-menu-item type="button" (click)="openSelectedDispatchRecipients('PENDING')" [disabled]="!selectedDispatchForActions">
        <mat-icon>hourglass_bottom</mat-icon>
        <span>Ver pendentes</span>
      </button>
      <button mat-menu-item type="button" (click)="openSelectedDispatchRecipients('DONE')" [disabled]="!selectedDispatchForActions">
        <mat-icon>task_alt</mat-icon>
        <span>Ver finalizados</span>
      </button>
      <button
        mat-menu-item
        type="button"
        class="danger-item"
        (click)="deleteSelectedDispatch()"
        [disabled]="!selectedDispatchForActions || dispatchDeleteId === selectedDispatchForActions.id"
        title="Excluir disparo e dados associados">
        <mat-icon>delete</mat-icon>
        <span>Excluir disparo</span>
      </button>
    </mat-menu>
  </section>
</div>

<!-- Pendentes -->
<div class="cs-modal-backdrop" *ngIf="pendingModalOpen" (click)="closePendingModal()"></div>
<section class="cs-modal recipients-modal" *ngIf="pendingModalOpen" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>{{ 'CONTROLSIGN.PENDING_TITLE' | translate }}</h2>
      <p>{{ activeDocument?.title }}</p>
    </div>
    <button type="button" class="close" (click)="closePendingModal()">&times;</button>
  </header>

  <div class="filter">
    <mat-icon>search</mat-icon>
    <input type="text" [placeholder]="'CONTROLSIGN.FILTER_DOC' | translate" [(ngModel)]="pendingSearch">
  </div>

  <div class="recipients-list">
    <article class="recipient-card" *ngFor="let item of paginateRecipients(filteredPending(), pendingPage)">
      <div class="avatar">{{ (item.user_name || 'U').charAt(0).toUpperCase() }}</div>
      <div class="info">
        <p class="name">{{ item.user_name || ('CONTROLSIGN.EMPTY' | translate) }}</p>
        <p class="email">{{ item.email || ('CONTROLSIGN.EMPTY' | translate) }}</p>
        <small class="document-meta">{{ 'CONTROLSIGN.DOCUMENT' | translate }}: {{ item.title }}</small>
      </div>
      <div class="meta-info">
        <span class="label">{{ 'CONTROLSIGN.SENT_AT' | translate }}</span>
        <strong>{{ item.sent_at | date:'short' }}</strong>
        <button
          type="button"
          class="resend-btn"
          *ngIf="canResendEmail(item)"
          [disabled]="resendingRecipientIds.has(item.recipient_id)"
          (click)="resendRecipientEmail(item)">
          {{ resendingRecipientIds.has(item.recipient_id) ? 'Reenviando...' : 'Reenviar e-mail' }}
        </button>
      </div>
    </article>
    <p class="empty" *ngIf="!filteredPending().length && !recipientsLoading.pending">{{ 'CONTROLSIGN.NO_PENDING' | translate }}</p>
    <p class="list-status" *ngIf="recipientsLoading.pending">{{ 'COMMON.LOADING_LIST' | translate }}</p>
  </div>

  <div class="pagination" *ngIf="filteredPending().length > recipientsPageSize">
    <button type="button" (click)="movePendingPage(-1)" [disabled]="pendingPage === 1">{{ 'PAGINATION.PREV' | translate }}</button>
    <span>{{ 'PAGINATION.PAGE' | translate:{ current: pendingPage, total: pendingTotalPages } }}</span>
    <button type="button" (click)="movePendingPage(1)" [disabled]="pendingPage >= pendingTotalPages">{{ 'PAGINATION.NEXT' | translate }}</button>
  </div>
  </section>

<!-- Finalizados -->
<div class="cs-modal-backdrop" *ngIf="completedModalOpen" (click)="closeCompletedModal()"></div>
<section class="cs-modal recipients-modal" *ngIf="completedModalOpen" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>{{ 'CONTROLSIGN.DONE_TITLE' | translate }}</h2>
      <p>{{ activeDocument?.title }}</p>
    </div>
    <button type="button" class="close" (click)="closeCompletedModal()">&times;</button>
  </header>

  <div class="filter">
    <mat-icon>search</mat-icon>
    <input type="text" [placeholder]="'CONTROLSIGN.FILTER_USER' | translate" [(ngModel)]="completedSearch">
  </div>

  <div class="recipients-list">
    <article class="recipient-card completed" *ngFor="let item of paginateRecipients(filteredCompleted(), completedPage)">
      <div class="status-icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <div class="info">
        <p class="name">{{ item.user_name || '—' }}</p>
        <p class="email">{{ item.email || '—' }}</p>
        <small class="document-meta">Finalizado em {{ item.last_action_at | date:'short' }}</small>
      </div>
      <div class="actions ghost-actions">
        <a class="ghost" *ngIf="documentLink(item.file_path)" [href]="documentLink(item.file_path)" target="_blank">Documento</a>
        <button type="button" class="ghost" (click)="downloadProof(item)">Prova digital</button>
      </div>
    </article>
    <p class="empty" *ngIf="!filteredCompleted().length && !recipientsLoading.done">{{ 'CONTROLSIGN.NO_DONE' | translate }}</p>
    <p class="list-status" *ngIf="recipientsLoading.done">{{ 'COMMON.LOADING_LIST' | translate }}</p>
  </div>

  <div class="pagination" *ngIf="filteredCompleted().length > recipientsPageSize">
    <button type="button" (click)="moveCompletedPage(-1)" [disabled]="completedPage === 1">Anterior</button>
    <span>Página {{ completedPage }} de {{ completedTotalPages }}</span>
    <button type="button" (click)="moveCompletedPage(1)" [disabled]="completedPage >= completedTotalPages">Próxima</button>
  </div>
  </section>
